module.exports = __webpack_public_path__ + "img/shiyanshi-5.b7fd3604.png";